<template>
  <div class="trustAndSecurity">
    <!-- trustAndSecurity -->
    <p class="trustAndSecurityTitle">How can we improve?</p>
    <el-form ref="form" :model="form" class="trustAndSecurityForm">
      <el-form-item label="Name">
        <el-col :span="8">
          <el-input v-model="form.firstName" placeholder="First name"></el-input>
        </el-col>
        <el-col :span="8" :offset="1">
          <el-input v-model="form.lastName" placeholder="Last name"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="Email">
        <el-col :span="17">
          <el-input v-model="form.email" placeholder="example@email.com"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="Region">
        <el-col :span="17">
          <el-select v-model="form.region" placeholder="Mainland China">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-col> 
      </el-form-item>
      <el-form-item label="I am a">
        <el-col :span="17">
          <el-select v-model="form.careers" placeholder="Individual translator">
            <el-option label="区域一" value="1"></el-option>
            <el-option label="区域二" value="2"></el-option>
          </el-select>
        </el-col> 
      </el-form-item>
      <el-form-item>
        <div class="trustAndSecurityLine"></div>
      </el-form-item>
      <el-form-item label="Subject">
        <el-col :span="17">
          <el-input v-model="form.subject"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="Feedback">
        <el-col :span="17">
          <el-input type="textarea" :rows="8" v-model="form.feedback"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button :plain="true" @click="onSubmit">SUBMIT</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
      form:{
        firstName: '',
        lastName: '',
        email: '',
        region: '',
        careers: '',
        subject: '',
        feedback: ''
      }
      
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    onSubmit(){

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
@media only screen and (max-width: 880px){
  .trustAndSecurity .trustAndSecurityForm{
    width: 90%!important;
  }
  .trustAndSecurityForm .trustAndSecurityLine{
    width: 100%!important;
  }
  .trustAndSecurityForm .el-form-item{
    padding: 0px 10px 40px 20px !important;
  }
  .trustAndSecurityForm .el-form-item__label{
    width: 67px !important;
  }
  .trustAndSecurityTitle{
    font-size: 36px !important;
  }
  .trustAndSecurityForm .el-form-item .el-button{
    float: none !important;
    margin-right: 0!important;
  }
}
.trustAndSecurity{
  padding: 0;
  margin-top:40px;
  text-align:center;
  padding-bottom:80px;
}
.trustAndSecurityTitle{
  font-family: Montserrat;
  font-size: 48px;
  font-style: normal;
  font-weight: 500;
  line-height: 59px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 106px;
}
.trustAndSecurity .trustAndSecurityForm{
  width: 824px;
  height: auto;
  background: #FFFFFF;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  margin: 110px auto;
  padding-top: 65px;
}
.trustAndSecurityForm .el-form-item{
  padding: 0px 50px 40px 50px;
}
.trustAndSecurityForm .el-form-item__label{
  width: 150px;
  text-align: left;
}
.trustAndSecurityForm .el-form-item__content{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
}
.trustAndSecurityForm .el-select{
  width: 100%;
}
.trustAndSecurityForm .el-form-item .el-button{
  padding: 16px 42px;
  background: #222222;
  border-radius: 10px;
  color: white;
  float: right;
  margin-right: 62px;
}
.trustAndSecurityForm .trustAndSecurityLine{
  border: 1px solid #E5E5E5;
  width: 662px;
}
</style>




// WEBPACK FOOTER //
// src/components/TrustAndSecurity.vue